export interface Employees {
    employeeID: number;
    lastName: string;
    firstName: string;
    noDataEditOnHandy: number;
    workPlaceWithAdress: number;
    orderSearchString?: string;
    dayAgainActive: boolean;
    allowSaveHoursWithoutTime: boolean;
    allowTimerecordingInPast: boolean;
}

export class EmptyEmployee implements Employees {
    employeeID = 0;
    lastName = '';
    firstName = '';
    noDataEditOnHandy = 0;
    workPlaceWithAdress = 0;
    dayAgainActive = false;
    allowSaveHoursWithoutTime = false;
    allowTimerecordingInPast = false;
}

export interface EmpWorkPlan {
    objectNumber: string;
    objectID: string;
    serviceID: string;
    fK_EmployeeID: string;
    team: string;
    absence: string;
    mandator: string;
    objDescription: string;
    note4: string;
    manufacturingDescription: string;
    memo: string;
    dateOfDelivery: string;
    dateOfDeliveryOK?: number;
    startTime?: Date | undefined;
    endTime?: Date | undefined;
    customerWage?: number;
    expenseTravelTime?: number;
    drivingFlat?: number;
    manufactDetailsTrans: boolean;
    modified: boolean;
    serviceComplete: number;
    additionalWork: string;
    sA_Memo: string;
    sa_Memo_Add: string;
    sa_ManufactDetailsTrans: boolean;
    notes: string;
    rowID: string;
    fK_AutoCostCenter?: number;
    fK_EmpWorkPlanCategoryID?: number;
}

export interface EmpWeekPlan {
    objectNumber: string;
    objectID: string;
    fK_EmployeeID: string;
    team: string;
    mandator: string;
    objDescription: string;
    note4: string;
    manufacturingDescription: string;
    memo: string;
    dateOfDelivery: string;
    dateOfDeliveryOK?: number;
    planDay?: string | undefined;
    hours: number;
    customerWage?: number;
    expenseTravelTime?: number;
    drivingFlat?: number;
    manufactDetailsTrans: boolean;
    sA_Memo: string;
    sa_ManufactDetailsTrans: boolean;
    notes: string;
    rowID: string;
    fK_AutoCostCenter?: number;
    sort: number;
}
